import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "percentage-slider-container flex flex-column justify-content-between w-full" }
const _hoisted_2 = { class: "percentage-input w-full" }
const _hoisted_3 = { class: "percentage-slider w-full bg-white" }
const _hoisted_4 = { class: "slider-axis flex justify-content-between align-items-center" }

import { computed, inject, toRefs } from 'vue';
import Slider from 'primevue/slider';
import InputNumber from 'primevue/inputnumber';
import { PercentGoalInterface } from '@/types';
import { PERCENT_GOAL_PARAMS } from '@/enum';

interface PropsInterface {
  goal: PercentGoalInterface;
  attendeeId: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalsSlider',
  props: {
    goal: {},
    attendeeId: {}
  },
  setup(__props: any) {

const props = __props;
const { goal, attendeeId } = toRefs(props);
const update = inject('updatePercentageGoal') as (attendeeId: number, trialId: number, percentage: number) => void;

const sliderValue = computed({
  get: () => goal.value.percentage,
  set: (value) => {
    update(attendeeId.value, goal.value.treatment_goal_id, parseInt(value.toString()));
  },
});

const sliderAxisValues = ['0%', '25%', '50%', '75%', '100%'];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { for: "percentage-input" }, "Percentage", -1)),
      _createVNode(_unref(InputNumber), {
        id: "percentage-input",
        modelValue: sliderValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sliderValue).value = $event)),
        suffix: "%",
        min: _unref(PERCENT_GOAL_PARAMS).MIN_ALLOWED,
        max: _unref(PERCENT_GOAL_PARAMS).MAX_ALLOWED,
        placeholder: "Enter percentage or use slider",
        class: "flex flex-column align-items-start w-full p-0 py-2 font-bold",
        "input-class": "w-full",
        disabled: !!_unref(goal).completed_at
      }, null, 8, ["modelValue", "min", "max", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Slider), {
        modelValue: sliderValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sliderValue).value = $event)),
        disabled: !!_unref(goal).completed_at,
        min: _unref(PERCENT_GOAL_PARAMS).MIN_ALLOWED,
        max: _unref(PERCENT_GOAL_PARAMS).MAX_ALLOWED
      }, null, 8, ["modelValue", "disabled", "min", "max"]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sliderAxisValues, (value) => {
          return _createElementVNode("span", {
            key: value,
            class: "slider-axis-text"
          }, _toDisplayString(value), 1)
        }), 64))
      ])
    ])
  ]))
}
}

})